let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7JMo6")).then(() => parcelRequire('cCcsq'));